
<div class="row" style="border-bottom: 1px solid black">
  @if (showSearch) {
    <div class="userDetails">
      <div class="col-lg-3">
        <div class="customer-field-container">
          <div class="customer-label">
            {{'' | i18n: 'first-name'}}:
          </div>
          <div class="customer-field">
            <input id="customer-lookup" #searchFirst type="text"
              [(ngModel)]="searchFirstName" (keydown.enter)="searchForCustomer()"
              [disabled]="isAdminUser"
              autocomplete="new-password">
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="customer-field-container">
            <div class="customer-label">
              {{'' | i18n: 'last-name'}}:
            </div>
            <div class="customer-field">
              <input id="customer-lookup-last" type="text" autocomplete="new-password"
                [disabled]="(!editable || isAdminUser)"
                [(ngModel)]="searchLastName"
                (keydown.enter)="searchForCustomer()">
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="customer-field-container">
              <div class="customer-label">
                {{'' | i18n: 'dealership'}}:
              </div>
              <select [disabled]="(!editable || isAdminUser)" [(ngModel)]="selectedBuno">
                <option [value]="null">{{'' | i18n: 'select'}}</option>
                @for (dealer of dealerOptions; track dealer) {
                  <option [value]="dealer.buno">{{dealer.dealerName}}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-lg-1">
            <button [disabled]="(!editable || isAdminUser)" (click)="searchForCustomer()" class="search-icon">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>
          @if (searchError) {
            <div class="customer-error-search col-lg-5">
              {{'' | i18n: 'no-records-found'}}
            </div>
          }
        </div>
      }
      @if (searchOptions) {
        <div class="col-lg-6 search_results">
          @for (s of searchOptions; track s) {
            <div class="col-lg-12" (click)="selectSearchOption(s)" style="display: flex">
              <div class="col-lg-4">
                {{s.firstName + ' ' + s.lastName }}
              </div>
              <div class="col-lg-4">
                {{s.telephone}}
              </div>
              <div class="col-lg-4">
                {{s.city}}
              </div>
            </div>
          }
        </div>
      }

    </div>
    <form [formGroup]="customerDetailsForm">
      <div class="customer-main-row-container">
        <div [ngClass]="showField ? 'customer-main-three-columns' : 'customer-main-two-columns'">
          <div class="customer-field-container">
            <div class="customer-label">
              {{'' | i18n: 'initials'}}{{mandatoryIndicator}}:
            </div>
            <div class="customer-field">
              <input formControlName="initials" autocomplete="new-password" type="text">
            </div>
            @if (isFieldValid('initials')) {
              <div class="customer-error">
                {{'' | i18n: 'initials'}}
              </div>
            }
          </div>
          <div class="customer-field-container">
            <div class="customer-label">
              {{'' | i18n: 'first-name'}}*:
            </div>
            <div class="customer-field">
              <input formControlName="firstName"  autocomplete="new-password" type="text">
            </div>
            @if (isFieldValid('firstName')) {
              <div class="customer-error">
                {{'' | i18n: 'first-name'}}
              </div>
            }
          </div>
          <div class="customer-field-container">
            <div class="customer-label">
              {{'' | i18n: 'middle-name'}}:
            </div>
            <div class="customer-field">
              <input formControlName="middleName" autocomplete="new-password" type="text">
            </div>
          </div>
          <div class="customer-field-container">
            <div class="customer-label">
              {{'' | i18n: 'last-name'}}*:
            </div>
            <div class="customer-field">
              <input formControlName="lastName" autocomplete="new-password" type="text">
            </div>
            @if (isFieldValid('lastName')) {
              <div class="customer-error">
                {{'' | i18n: 'last-name'}}
              </div>
            }
          </div>
        </div>

        @if (showField) {
          <div [ngClass]="showField ? 'customer-main-three-columns' : 'customer-main-two-columns'">
            <div class="customer-field-container">
              <div class="customer-label">
                {{'' | i18n: 'date-of-birth'}}*:
              </div>
              <div class="customer-field">
                <input formControlName="dateOfBirth" type="date">
              </div>
              @if (isFieldValid('dateOfBirth')) {
                <div class="customer-error">
                  {{'' | i18n: 'date-of-birth'}}
                </div>
              }
            </div>
            <div class="customer-field-container">
              <div class="customer-label">
                {{'' | i18n: 'gender'}}*:
              </div>
              <div class="warranty-field">
                <input formControlName="gender" type="text">
              </div>
              @if (isFieldValid('gender')) {
                <div class="customer-error">
                  {{'' | i18n: 'gender'}}
                </div>
              }
            </div>
            <div class="customer-field-container">
              <div class="customer-label">
                {{'' | i18n: 'phone-number'}}*:
              </div>
              <div class="customer-field">
                <input formControlName="telephone" autocomplete="new-password" type="text">
              </div>
              @if (isFieldValid('telephone')) {
                <div class="customer-error">
                  {{'' | i18n: 'phone-number'}}
                </div>
              }
            </div>
            <div class="customer-field-container">
              <div class="customer-label">
                {{'' | i18n: 'email'}}:
              </div>
              <div class="customer-field">
                <input formControlName="email" autocomplete="new-password" type="text">
              </div>
            </div>
          </div>
        }

        <div [ngClass]="showField ? 'customer-main-three-columns' : 'customer-main-two-columns'">
          <div class="customer-field-container">
            <div class="street-address">
              <div class="street-number">
                <div class="customer-label">
                  {{'' | i18n: 'street-no'}}{{mandatoryIndicator}}:
                </div>
                <div class="customer-field">
                  <input formControlName="streetNumber" autocomplete="new-password" type="text">
                </div>
                @if (isFieldValid('streetNumber')) {
                  <div class="customer-error">
                    {{'' | i18n: 'street-no'}}
                  </div>
                }
              </div>
              <div class="street">
                <div class="customer-label">
                  {{'' | i18n: 'street'}}{{mandatoryIndicator}}:
                </div>
                <div class="customer-field">
                  <input formControlName="street" autocomplete="new-password" type="text">
                </div>
                @if (isFieldValid('street')) {
                  <div class="customer-error">
                    {{'' | i18n: 'street'}}
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="customer-field-container">
            <div class="customer-label">
              {{'' | i18n: 'post-code'}}{{mandatoryIndicator}}:
            </div>
            <div class="customer-field">
              <input formControlName="postCode" autocomplete="new-password" type="text">
            </div>
            @if (isFieldValid('postCode')) {
              <div class="customer-error">
                {{'' | i18n: 'post-code'}}
              </div>
            }
          </div>
          <div class="customer-field-container">
            <div class="customer-label">
              {{'' | i18n: 'city'}}{{mandatoryIndicator}}:
            </div>
            <div class="customer-field">
              <input formControlName="city" autocomplete="new-password" type="text" >
            </div>
            @if (isFieldValid('city')) {
              <div class="customer-error">
                {{'' | i18n: 'city'}}
              </div>
            }
          </div>
          <div class="customer-field-container">
            <div class="customer-label">
              {{'' | i18n: 'company'}}:
            </div>
            <div class="customer-field">
              <input formControlName="company" autocomplete="new-password" type="text">
            </div>
          </div>
        </div>
      </div>
    </form>
